// extracted by css-extract-rspack-plugin
export default {"bottomSheetText":"bottom-sheet-text--TUxxPnOtXMQo1DS3"};